// 基础路由文件
import { NotFound, NoMessage } from 'vue-common-laboratory' //404
import index from '@/views/portal/search.vue' //门户首页
import DoorLayout from '@/views/portal/doorLayout.vue'
import video from '@/views/portal/ceshiIndex.vue'
import courseDetail from '@/views/portal/search/detail.vue'//课程展示

const config = this.$config

let routes = [
  {
    label: 'notFound',
    path: '/error',
    name: 'errorPage',
    meta: { config: config },
    component: NotFound,

  },
  {
    label: 'NoMessage',
    path: '/NoMessage',
    name: 'NoMessage',
    component: NoMessage
  },
  {
    label: 'video上传与播放组件',
    path: '/portal/ceshiIndex',
    name: 'video上传与播放组件',
    component: video
  },
  {
    label: '',
    path: '/',
    redirect: '/portal/search',
    name: 'doorlayout',
    component: DoorLayout,
    children: [
      {
        label: '平台检索',
        path: '/portal/search',
        meta: { showSearch: true },
        name: '平台检索',
        component: index
      },
      {
        label: '课程展示',
        path: '/portal/search/detail',
        meta: { showSearch: true },
        name: '课程展示',
        component: courseDetail,
      },
    ]
  },

];

export default routes;


// WEBPACK FOOTER //
// ./src/router/map/base.js